import createSagaMiddleware from "redux-saga"
import {combineReducers, configureStore} from "@reduxjs/toolkit";
import appSlice from "./app/appReducer";
import rootSaga from "../saga/rootSaga";
import snackBarSlice from "./snackbar/snackbarReducer";
import menuSlice from "./menu/menuReducer";
import authSlice from "./auth/authReducer";
import userSlice from "./User/UserReducer"
import municipalitySlice from "./Municipality/MunicipalityReducer"
import AdoptionSlice from "./Adoption/AdoptionReducer";
import DogSlice from "./Dog/DogReducer";
import treatmentSlice from "./Treatment/TreatmentReducer"
import BoxSlice from "./Box/BoxReducer"
import tenantSlice from "./Tenant/TenantReducer"
import ShedSlice from "./Shed/ShedReducer"
import multimediaSlice from "./Multimedia/MultimediaReducer"
import userAdminSlice from "./User/Admin/UserReducerAdmin"

let sagaMiddleware = createSagaMiddleware()

const combinedReducer = combineReducers({
    app: appSlice,
    auth: authSlice,
    snackbar: snackBarSlice,
    menu: menuSlice,
    userElement : userSlice,
    userAdminElement : userAdminSlice,
    tenantElement : tenantSlice,
    municipalityElement: municipalitySlice,
    AdoptionElement: AdoptionSlice,
    DogElement: DogSlice,
    treatmentElement: treatmentSlice,
    AdoptionSlice: AdoptionSlice,
    boxElement: BoxSlice,
    shedElement:ShedSlice,
    multimediaElement: multimediaSlice,
});

const rootReducer = (state: ReturnType<typeof combinedReducer> | undefined, action: any) => {
    if (action.type === 'reset') {
        // Return the initial state by passing `undefined`
        return combinedReducer(undefined, action);
    }
    return combinedReducer(state, action);
};

const store = configureStore({
    reducer: rootReducer,
    middleware: getDefaultMiddleware => getDefaultMiddleware({serializableCheck: false}).concat(sagaMiddleware)
})

sagaMiddleware.run(rootSaga)

export default store